/**
 * Created by wwei on 2018-10-09.
 */

import React, { Component } from "react";

class SvgIcon extends Component {
  render() {
    const { name } = this.props;
    return <i className={`svg-icon icon-${name}`} {...this.props} />;
  }
}

export default SvgIcon;



// WEBPACK FOOTER //
// ./src/common/components/SvgIcon.js